import { withFilters, Button } from '@wordpress/components';
import { RawHTML, Fragment } from '@wordpress/element';
import { __, sprintf } from '@wordpress/i18n';
import { lock } from '@wordpress/icons';

export const Promo = withFilters( 'popper.tabs.promo' )( () => {
	return (
		<Fragment>
			<RawHTML>
				{ sprintf(
					/* translators: Link to site. */
					// eslint-disable-next-line @wordpress/i18n-no-collapsible-whitespace, @wordpress/i18n-translator-comments
					__(
						`<p>This is a PRO feature. With %s you can add mail services integrations <br />
						(Mailchimp, ConvertKit, MailPoet, GetResponse and more…) to your popups.</p>
						<p>Please upgrade to the PRO plan to unlock all these awesome features.</p>`,
						'popper'
					),
					`<a href="https://www.popperwp.com/" target="_blank">Popper Pro</a>`
				) }
			</RawHTML>
			<Button
				variant="primary"
				href="https://www.popperwp.com/"
				icon={ lock }
				iconPosition={ 'left' }
				target="_blank"
				size="compact"
			>
				{ __( 'Try it now!', 'popper' ) }
			</Button>
		</Fragment>
	);
} );
